import * as session from './lib/session';
import * as answerIdentifiers from './lib/answerIdentifiers';
import * as category from './lib/category';
import * as allCategories from './lib/allCategories';
import * as reports from './lib/reports';
import * as widgets from './lib/widgets';
import * as feedbacks from './lib/feedbacks';
import * as savedFilters from './lib/savedFilters';
import * as defaultSavedFilters from './lib/defaultSavedFilters';
import * as exports from './lib/exports';
import * as insights from './lib/insights';
import * as photoTags from './lib/photoTags';
import * as campaigns from './lib/campaigns';
import * as companies from './lib/companies';
import loadGallery from './lib/gallery';
import loadCurrentUser from './lib/currentUser';

const API = {
  answerIdentifiers,
  session,
  category,
  allCategories,
  reports,
  feedbacks,
  savedFilters,
  defaultSavedFilters,
  exports,
  insights,
  gallery: {
    load: loadGallery,
  },
  photoTags,
  campaigns,
  widgets,
  companies,
  currentUser: {
    load: loadCurrentUser,
  },
};

export default API;
